export default __webpack_public_path__ + "static/media/avatar-2.4a140370.jpg";